import React from "react";

const Tooltip = ({ text }) => (
    <span className="savings-calculator__tooltip" tabIndex={0} aria-label={text}>
        <svg
            className="savings-calculator__tooltip-icon"
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <path
                d="M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM10 18.3036C5.41518 18.3036 1.69643 14.5848 1.69643 10C1.69643 5.41518 5.41518 1.69643 10 1.69643C14.5848 1.69643 18.3036 5.41518 18.3036 10C18.3036 14.5848 14.5848 18.3036 10 18.3036Z"
                fill="currentColor"
            />
            <path
                d="M8.92822 6.07143C8.92822 6.35559 9.04111 6.62811 9.24204 6.82904C9.44297 7.02998 9.71549 7.14286 9.99965 7.14286C10.2838 7.14286 10.5563 7.02998 10.7573 6.82904C10.9582 6.62811 11.0711 6.35559 11.0711 6.07143C11.0711 5.78727 10.9582 5.51475 10.7573 5.31381C10.5563 5.11288 10.2838 5 9.99965 5C9.71549 5 9.44297 5.11288 9.24204 5.31381C9.04111 5.51475 8.92822 5.78727 8.92822 6.07143ZM10.5354 8.57143H9.46394C9.36572 8.57143 9.28537 8.65179 9.28537 8.75V14.8214C9.28537 14.9196 9.36572 15 9.46394 15H10.5354C10.6336 15 10.7139 14.9196 10.7139 14.8214V8.75C10.7139 8.65179 10.6336 8.57143 10.5354 8.57143Z"
                fill="currentColor"
            />
        </svg>

        <span className="savings-calculator__tooltip-bubble" role="tooltip">
            {text}
        </span>
    </span>
);

export default Tooltip;
